import { useContext } from 'react';

import { TrackingContext } from './Tracking';

/** @deprecated use `@/lib/gtm` module instead */
export default function useTracking() {
  return useContext(TrackingContext);
}
